<template>
  <div class="documenti-mobile" v-loading="loading">
    <div class="row row-custom documenti-header">
      <div class="col-24 titolo no-padding">
        <span>{{ $t('documenti.label.title') }}</span>
      </div>
    </div>

    <el-table :data="documenti" :empty-text="$t('documenti.msg.noData')" class="custom-table">

      <el-table-column prop="titolo" :label="$t('documenti.label.docTitolo')" min-width="200">
      </el-table-column>

      <el-table-column header-align="center" align="center" prop="dataDocumento" :label="$t('documenti.label.docData')"
        width="80">

        <template slot-scope="scope">
          <div class="name-wrapper">
            {{ scope.row.dataDocumento | formattaData }}
          </div>
        </template>

      </el-table-column>

      <el-table-column width="40" header-align="center" align="center">
        <template slot-scope="scope">
          <div class="actions">
            <icon name="riv-attach" scale="1.2" @click.native.stop="getAllegato(scope.row)"></icon>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination v-if="(nrPages > 1)" :current-page="currentPage" background layout="prev, pager, next"
      :total="nrItems" :page-size="pag_for" @current-change="changePage">
    </el-pagination>
  </div>

</template>

<script>
import mixinDownload from "../../assets/mixins/downloadDoc.js";
import moment from 'moment'

export default {
  name: 'DocumentiMobile',
  props: ['trasferta'],
  mixins: [mixinDownload],
  i18n: {
    messages: {
      it_IT: {
        documenti: {
          label: {
            title: 'Documenti',
            docTitolo: 'Nome Documento',
            allegati: 'Allegati',
            docData: 'Data',
            docUser: 'Segreteria'
          },
          msg: {
            noData: 'Nessun Documento Caricato'
          }
        }
      },
      fr_FR: {
        documenti: {
          label: {
            title: 'Gestion de documents',
            docTitolo: 'Nom du document',
            allegati: 'Annexes',
            docData: 'Date',
            docUser: 'Secrétariat'
          },
          msg: {
            noData: 'Aucun Document trouvé'
          }
        }
      },
      es_ES: {
        documenti: {
          label: {
            title: 'Gestión de documentos',
            docTitolo: 'Nombre del documento',
            allegati: 'Adjuntos',
            docData: 'Fecha',
            docUser: 'Secretaría'
          },
          msg: {
            noData: 'Ningún documento cargado'
          }
        }
      },
      de_DE: {
        documenti: {
          label: {
            title: 'Dienstreise',
            docTitolo: 'Dokumentname',
            allegati: 'Anlage',
            docData: 'Datum',
            docUser: 'Sekretariat'
          },
          msg: {
            noData: 'Keine Dokument gefunden'
          }
        }
      },
      en_GB: {
        documenti: {
          label: {
            title: 'Documents',
            docTitolo: 'Document name',
            allegati: 'Attach',
            docData: 'Date',
            docUser: 'Secretary'
          },
          msg: {
            noData: 'No document loaded'
          }
        }
      }
    }
  },
  data() {
    return {
      loading: false,
      documenti: [],
      currentPage: 1,
      pag_for: 8,
      pag_order: 'DD',
      nrPages: 0,
      nrItems: 0,
      form: {},
      tbl_mezzi: [],
      visibleInfo: false
    }
  },
  filters: {
    /* Formatta la data: GGMMAAAA --> GG/MM/AAAA */
    formattaData: function (date) {
      if (date !== '') {
        return date.substr(6, 2) + '/' + date.substr(4, 2) + '/' + date.substr(0, 4)
      } else {
        return ' '
      }
    },
    formattaHours: function (hours) {
      if (hours !== '') {
        return hours.replace(',', ':')
      } else {
        return ' '
      }
    }
  },
  beforeMount: function () {
    this.loading = true
    this.loadDocumenti()
  },
  mounted: function () {
  },
  methods: {
    loadDocumenti: function () {
      this.loading = true
      this.$set(this, 'documenti', [])
      this.$http.get('trasferte/' + this.$store.state.country + '/documenti', {
        params: {
          idTrasferta: this.trasferta.idTrasferta,
          pag_action: (this.currentPage > 1) ? 'NEXT' : 'BEGIN',
          pag_from: this.currentPage,
          pag_for: this.pag_for,
          pag_order: this.pag_order
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.documenti = response.body.data
            if (this.currentPage === 1) {
              this.$set(this, 'nrPages', parseInt(response.body.attrib.pages))
              this.$set(this, 'nrItems', parseInt(response.body.attrib.size))
            }
          } else {
            if (response.body.msg[0].msgId !== '1218') {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
            this.$set(this, 'documenti', [])
            this.$set(this, 'nrPages', 0)
            this.$set(this, 'nrItems', 0)
          }
          this.loading = false
        })
    },
    changePage: function (page) {
      this.currentPage = page
      this.loadDocumenti()
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";
@import "../../assets/less/mobile_customize.less";
@import "../../assets/less/el-table_mobile.less";
@import "../../assets/less/el-form_mobile.less";

.documenti-mobile {
  // height: 100%;
  //min-width: 1250px;
  margin-bottom: 70px;
  max-width: 100%;

  .documenti-header {
    height: 40px;
    margin-top: 10px;
    margin-bottom: 10px;

    .titolo {
      .set-font(@size: 16px, @color: @greenRiva, @family: "os-bold");
      text-align: left;
      line-height: 40px;
    }

    .action {
      text-align: right;
      line-height: 40px;

      .add {
        // position: fixed;
        // right: 20px;
        // bottom: 20px;
        float: right;
        color: #FF791A;
        margin-right: 10px;
        margin-left: 10px;
      }

      .send {
        // position: fixed;
        // right: 20px;
        // bottom: 20px;
        float: right;
        color: #FF791A;
        margin-right: 10px;
        margin-left: 10px;
      }
    }
  }

  .popover-mobile {
    line-height: 50px;
    .set-font(@size: 18px, @color: @grayTesto, @family: "os-semibold")
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TrasferteMobile/DocumentiMobile.vue